import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseAddressSearch = () => {
  const warehouseAddressSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/address/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { warehouseAddressSearch }
}

export default InteractorWarehouseAddressSearch
